import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Types"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M22.5 12L16.5 18L15.4395 16.9395L20.379 12L15.4395 7.0605L16.5 6L22.5 12ZM11.4698 16.2802C11.6103 16.4211 11.8011 16.5002 12.0001 16.5C12.199 16.5002 12.3898 16.4211 12.5303 16.2802L16.2803 12.5302C16.5731 12.2374 16.5731 11.7626 16.2803 11.4697L12.5303 7.71974C12.2374 7.42696 11.7627 7.42696 11.4698 7.71974L7.7198 11.4697C7.42702 11.7626 7.42702 12.2374 7.7198 12.5302L11.4698 16.2802ZM12 14.6895L9.31048 12L12 9.31048L14.6895 12L12 14.6895ZM1.5 12L7.5 6L8.5605 7.0605L3.621 12L8.5605 16.9395L7.5 18L1.5 12Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Types.vue"]]);
